module.exports = __webpack_public_path__ + "img/MOBILE_Slide1.daac4ec6.png";